var globalFunctions = require("./globalFunctions.js");

module.exports = {
  element: document.querySelector("#moreModals"),

  render: function(odds) {
    this.element.innerHTML = "";
    var self = this;
    odds.forEach(function(odd) {
      self.renderBody(odd);
    });
  },

  renderBody: function(odd) {
    var html = "";
    html +=
      '<div class="modal fade moreGames" id="' + odd.ID + '">' +
      '<div class="modal-dialog" role="document">' +
      '<div class="modal-content">' +
      '<div class="modal-body">' +
      '<div type="" class="close" data-dismiss="modal" aria-label="Close">'+
      '<span aria-hidden="true">&times;</span>'+
      '</div>' +
      '<div class="modal-game-title"><h4>' + odd.CodeHome + '</h4> <span>-</span> <h4>' + odd.CodeAway + '</h4></div>' +
      '<div class="popup-fix games-table-header-holder">' +
      '<div class="games-table-header games-table-title">Home Correct Score</div>' +
      '<div class="games-table-more-odds-home-holder">' +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>1:0</li>" +
      "<li>2:0</li>" +
      "<li>3:0</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>4:0</li>" +
      "<li>5:0</li>" +
      "<li>6:0</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>2:1</li>" +
      "<li>3:1</li>" +
      "<li>4:1</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>5:1</li>" +
      "<li>3:2</li>" +
      "<li>4:2</li>" +
      "</ul>" +
      "</div>" +
      "</div>" +
      "</div>" +
      '<div class="games-table-holder" data-id="'+odd.ID+'" data-homeTeam="'+odd.TeamNameHome+'" data-awayTeam="'+odd.TeamNameAway+'">' +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li data-betType="1:0" data-betCode="610" class="bet-choose"' +
      'data-odd="'+odd.Score10+'">' + globalFunctions.checkQuotes(odd.Score10) + '</li>' +
      '<li data-bettype="2:0" data-betcode="620" class="bet-choose"' +
      'data-odd="'+odd.Score20+'">' + globalFunctions.checkQuotes(odd.Score20) + '</li>' +
      '<li data-bettype="3:0" data-betcode="630" class="bet-choose"' +
      'data-odd="'+odd.Score30+'">' + globalFunctions.checkQuotes(odd.Score30) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li  data-bettype="4:0" data-betcode="640" class="bet-choose"' +
      'data-odd="'+odd.Score40+'">' + globalFunctions.checkQuotes(odd.Score40) + '</li>' +
      '<li  data-bettype="5:0" data-betcode="650" class="bet-choose"' +
      'data-odd="'+odd.Score50+'">' + globalFunctions.checkQuotes(odd.Score50) + '</li>' +
      '<li  data-bettype="6:0" data-betcode="660" class="bet-choose"' +
      'data-odd="'+odd.Score60+'">' + globalFunctions.checkQuotes(odd.Score60) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li data-bettype="2:1" data-betcode="621" class="bet-choose"' +
      'data-odd="'+odd.Score21+'">' + globalFunctions.checkQuotes(odd.Score21) + '</li>' +
      '<li data-bettype="3:1" data-betcode="631" class="bet-choose"' +
      'data-odd="'+odd.Score31+'">' + globalFunctions.checkQuotes(odd.Score31) + '</li>' +
      '<li data-bettype="4:1" data-betcode="641" class="bet-choose"' +
      'data-odd="'+odd.Score41+'">' + globalFunctions.checkQuotes(odd.Score41) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li  data-bettype="5:1" data-betcode="651" class="bet-choose"' +
      'data-odd="'+odd.Score51+'">' + globalFunctions.checkQuotes(odd.Score51) + '</li>' +
      '<li  data-bettype="3:2" data-betcode="632" class="bet-choose"' +
      'data-odd="'+odd.Score32+'">' + globalFunctions.checkQuotes(odd.Score32) + '</li>' +
      '<li  data-bettype="4:2" data-betcode="642" class="bet-choose"' +
      'data-odd="'+odd.Score42+'">' + globalFunctions.checkQuotes(odd.Score42) + '</li>' +
      "</ul>" +
      "</div>" +
      "</div>" +
      '<div class="popup-fix games-table-header-holder">' +
      '<div class="games-table-header games-table-title">Away Correct Score</div>' +
      '<div class="games-table-more-odds-home-holder">' +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>0:1</li>" +
      "<li>0:2</li>" +
      "<li>0:3</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>0:4</li>" +
      "<li>0:5</li>" +
      "<li>0:6</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>1:2</li>" +
      "<li>1:3</li>" +
      "<li>1:4</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      "<li>1:5</li>" +
      "<li>2:3</li>" +
      "<li>2:4</li>" +
      "</ul>" +
      "</div>" +
      "</div>" +
      "</div>" +
      '<div class="games-table-holder" data-id="'+odd.ID+'" data-homeTeam="'+odd.TeamNameHome+'" data-awayTeam="'+odd.TeamNameAway+'">' +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li  data-bettype="0:1" data-betcode="601" class="bet-choose"' +
      'data-odd="'+odd.Score01+'">' + globalFunctions.checkQuotes(odd.Score01) + '</li>' +
      '<li  data-bettype="0:2" data-betcode="602" class="bet-choose"' +
      'data-odd="'+odd.Score02+'">' + globalFunctions.checkQuotes(odd.Score02) + '</li>' +
      '<li  data-bettype="0:3" data-betcode="603" class="bet-choose"' +
      'data-odd="'+odd.Score03+'">' + globalFunctions.checkQuotes(odd.Score03) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li  data-bettype="0:4" data-betcode="604" class="bet-choose"' +
      'data-odd="'+odd.Score04+'">' + globalFunctions.checkQuotes(odd.Score04) + '</li>' +
      '<li  data-bettype="0:5" data-betcode="605" class="bet-choose"' +
      'data-odd="'+odd.Score05+'">' + globalFunctions.checkQuotes(odd.Score05) + '</li>' +
      '<li  data-bettype="0:6" data-betcode="606" class="bet-choose"' +
      'data-odd="'+odd.Score06+'">' + globalFunctions.checkQuotes(odd.Score06) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li  data-bettype="1:2" data-betcode="612" class="bet-choose"' +
      'data-odd="'+odd.Score12+'">' + globalFunctions.checkQuotes(odd.Score12) + '</li>' +
      '<li  data-bettype="1:3" data-betcode="613" class="bet-choose"' +
      'data-odd="'+odd.Score13+'">' + globalFunctions.checkQuotes(odd.Score13) + '</li>' +
      '<li  data-bettype="1:4" data-betcode="614" class="bet-choose"' +
      'data-odd="'+odd.Score14+'">' + globalFunctions.checkQuotes(odd.Score14) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-home">' +
      "<ul>" +
      '<li  data-bettype="1:5" data-betcode="615" class="bet-choose"' +
      'data-odd="'+odd.Score15+'">' + globalFunctions.checkQuotes(odd.Score15) + '</li>' +
      '<li  data-bettype="2:3" data-betcode="623" class="bet-choose"' +
      'data-odd="'+odd.Score23+'">' + globalFunctions.checkQuotes(odd.Score23) + '</li>' +
      '<li  data-bettype="2:4" data-betcode="624" class="bet-choose"' +
      'data-odd="'+odd.Score24+'">' + globalFunctions.checkQuotes(odd.Score24) + '</li>' +
      "</ul>" +
      "</div>" +
      "</div>" +
      '<div class="popup-fix games-table-header-holder">' +
      '<div class="games-table-header games-table-title">Draw Correct Score</div>' +
      '<div class="games-table-more-odds-home-holder">' +
      '<div class="games-table-header games-table-tree games-table-more-odds-draw">' +
      "<ul>" +
      "<li>0:0</li>" +
      "<li>1:1</li>" +
      "</ul>" +
      "</div>" +
      '<div class="games-table-header games-table-tree games-table-more-odds-draw">' +
      "<ul>" +
      "<li>2:2</li>" +
      "<li>3:3</li>" +
      "</ul>" +
      "</div>" +
      "</div>" +
      "</div>" +
      '<div class="games-table-holder" data-id="'+odd.ID+'" data-homeTeam="'+odd.TeamNameHome+'" data-awayTeam="'+odd.TeamNameAway+'">' +
      '<div class="games-table games-table-tree games-table-more-odds-draw">' +
      "<ul>" +
      '<li  data-bettype="0:0" data-betcode="600" class="bet-choose"' +
      'data-odd="'+odd.Score00+'">' + globalFunctions.checkQuotes(odd.Score00) + '</li>' +
      '<li  data-bettype="1:1" data-betcode="611" class="bet-choose"' +
      'data-odd="'+odd.Score11+'">' + globalFunctions.checkQuotes(odd.Score11) + '</li>' +
      "</ul>" +
      "</div>" +
      '<div class="games-table games-table-tree games-table-more-odds-draw">' +
      "<ul>" +
      '<li  data-bettype="2:2" data-betcode="622" class="bet-choose"' +
      'data-odd="'+odd.Score22+'">' + globalFunctions.checkQuotes(odd.Score22) + '</li>' +
      '<li  data-bettype="3:3" data-betcode="633" class="bet-choose"' +
      'data-odd="'+odd.Score33+'">' + globalFunctions.checkQuotes(odd.Score33) + '</li>' +
      "</ul>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>";
    this.element.innerHTML = this.element.innerHTML + html;
  },

  refresh: function() {
    $('.modal').modal('hide');
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/other-score-modal.js
// module id = 2022
// module chunks = 4